import "./index.scss";

import { Component } from "react";
import PropTypes from "prop-types";
import Modal from "react-modal";
import classnames from "classnames";
import { useNavigate } from "react-router-dom";

import { SENSITIVE_CLASS } from "common/core/sensitive_label";
import Icon from "common/core/icon";
import MODAL_DEFAULTS from "config/modal";
import { TRANSITION_LEAVE_TIMEOUT } from "constants/globals";
import { DocumentEntitler } from "common/accessibility/document_title";

class BlockingModal extends Component {
  closeAction = () => {
    const { onRequestClose, closeRoute, backRoute, navigate } = this.props;
    onRequestClose?.();
    const route = closeRoute || backRoute;
    route && navigate(route);
  };

  render() {
    const {
      children,
      style,
      isOpen,
      onRequestClose,
      className,
      portalClassName,
      overlayClassName,
      contentClassName,
      transparent,
      closeRoute,
      backRoute,
      automationId,
      disclaimer,
      documentTitle,
      priorityForDocumentTitle,
    } = this.props;

    const cx = classnames("BlockingModal", SENSITIVE_CLASS, className, {
      BlockingModal__transparent: transparent,
    });

    const disclaimerCx = classnames(cx, "BlockingModal--disclaimer");

    const closeCx = classnames("close-modal", {
      hidden: !backRoute && !closeRoute && !onRequestClose,
    });

    const iconName = backRoute ? "arrow-left" : "x";

    const baseStyleContent = transparent
      ? {
          border: "none",
          backgroundColor: "transparent",
          boxShadow: "none",
        }
      : {
          // eventually move this into MODAL_DEFAULTS once everywhere that uses MODAL_DEFAULTS has
          // been moved over to BlockingModal
          // need to increase this from our standard 3px due to the shadow making the radius look sharper
          borderRadius: "4px",
          border: "1px solid #abc0d3", // $grey
          boxShadow: "0 3px 6px -1px rgba(0, 0, 0, 0.2)",
        };

    const modalStyle = {
      content: {
        ...MODAL_DEFAULTS.content,
        ...baseStyleContent,
        ...style?.content,
      },
      overlay: {
        ...MODAL_DEFAULTS.overlay,
        ...style?.overlay,
      },
    };

    return (
      <div>
        <Modal
          isOpen={isOpen}
          onRequestClose={onRequestClose}
          style={modalStyle}
          closeTimeoutMS={TRANSITION_LEAVE_TIMEOUT}
          portalClassName={portalClassName}
          overlayClassName={overlayClassName}
          className={contentClassName}
        >
          {documentTitle && (
            <DocumentEntitler
              title={documentTitle}
              priority={priorityForDocumentTitle ?? "modal"}
            />
          )}
          <div className={cx} data-automation-id={automationId || "blocking-modal"}>
            <Icon className={closeCx} name={iconName} onClick={this.closeAction} />
            {children}
          </div>
          {disclaimer && <div className={disclaimerCx}>{disclaimer}</div>}
        </Modal>
      </div>
    );
  }
}

BlockingModal.propTypes = {
  children: PropTypes.node,
  style: PropTypes.object,
  isOpen: PropTypes.bool,
  onRequestClose: PropTypes.func,
  className: PropTypes.string,
  portalClassName: PropTypes.string,
  contentClassName: PropTypes.string,
  disclaimer: PropTypes.node,
  documentTitle: PropTypes.string,
  priorityForDocumentTitle: PropTypes.string,
};

export default (props) => <BlockingModal {...props} navigate={useNavigate()} />;
